import axios from "axios";

const api = axios.create({baseURL: '/webservice'});

export default api;
